export const CONTENT_STATUSES = ['DRAFT', 'PUBLISHED', 'HIDDEN'] as const;
export type ContentStatus = (typeof CONTENT_STATUSES)[number];

/** Engagement state of a project (shown as a badge), independent of its publishing status. */
export const PROJECT_STAGES = ['ACTIVE', 'COMPLETED'] as const;
export type ProjectStage = (typeof PROJECT_STAGES)[number];

export const CONTACT_STATUSES = ['NEW', 'READ', 'ARCHIVED', 'SPAM'] as const;
export type ContactStatus = (typeof CONTACT_STATUSES)[number];

export const SUBSCRIBER_STATUSES = [
  'PENDING',
  'SUBSCRIBED',
  'UNSUBSCRIBED',
  'BOUNCED',
  'COMPLAINED',
] as const;
export type SubscriberStatus = (typeof SUBSCRIBER_STATUSES)[number];

export const SUBSCRIBER_SOURCES = ['WEBSITE', 'ADMIN', 'IMPORT'] as const;
export type SubscriberSource = (typeof SUBSCRIBER_SOURCES)[number];

export const CAMPAIGN_STATUSES = [
  'DRAFT',
  'SCHEDULED',
  'SENDING',
  'SENT',
  'PARTIALLY_FAILED',
  'FAILED',
  'CANCELLED',
] as const;
export type CampaignStatus = (typeof CAMPAIGN_STATUSES)[number];

export const DELIVERY_STATUSES = [
  'QUEUED',
  'SENDING',
  'ACCEPTED',
  'DELIVERED',
  'BOUNCED',
  'COMPLAINED',
  'FAILED',
  'SKIPPED',
] as const;
export type DeliveryStatus = (typeof DELIVERY_STATUSES)[number];

export const SOCIAL_PLATFORMS = [
  'x',
  'linkedin',
  'instagram',
  'behance',
  'dribbble',
  'facebook',
  'tiktok',
  'youtube',
  'whatsapp',
  'email',
  'website',
] as const;
export type SocialPlatform = (typeof SOCIAL_PLATFORMS)[number];

export const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/avif',
  'image/svg+xml',
] as const;

export const ATTACHMENT_MIME_TYPES = [
  'application/pdf',
  'application/zip',
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'text/plain',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
] as const;

/** Total attachment size per email. Most providers cap the full message near 25–40 MB; we stay well below. */
export const MAX_TOTAL_ATTACHMENTS_BYTES = 10 * 1024 * 1024;
export const MAX_ATTACHMENTS_PER_CAMPAIGN = 5;

/** Brand palette, used for project accents and the email renderer. */
export const BRAND = {
  primary: '#FA9A21',
  primaryHover: '#FF8900',
  primaryDeep: '#CD6D00',
  ink: '#1E1E1E',
  inkSoft: '#2E2E2E',
  muted: '#797979',
  border: '#EAEAEA',
  surface: '#F7F7F7',
} as const;

export const ACCENT_SWATCHES = [
  '#FA9A21',
  '#FF8900',
  '#CD6D00',
  '#1E1E1E',
  '#886652',
  '#3567B2',
  '#679CEB',
  '#2E6CC9',
  '#0F7D7F',
  '#20898C',
  '#004648',
  '#E00855',
  '#070659',
  '#1F1DB6',
  '#DBFA9D',
] as const;
